export const APPLICATION_STATUSES = {
  draft: "draft",
  awaiting: "awaiting",
  verified: "verified",
  confirmed: "confirmed",
  canceled: "rejected",
};
